import request from '@/utils/request'

// 绑定房屋和表档案信息
export function bindRoomMeterArchive(data) {
  return request({
    url: '/meterArchive.bindRoomMeterArchive',
    method: 'post',
    data
  })
}


// 查询用户表档案信息
export function queryMeterUserArchives(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/meterArchive.queryMeterUserArchives',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}